var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C7.79088 4 6.00002 5.79086 6.00002 8C6.00002 10.2091 7.79088 12 10 12C12.2092 12 14 10.2091 14 8C14 5.79086 12.2092 4 10 4ZM8.00002 8C8.00002 6.89543 8.89545 6 10 6C11.1046 6 12 6.89543 12 8C12 9.10457 11.1046 10 10 10C8.89545 10 8.00002 9.10457 8.00002 8Z",
    fill: "#3C83ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3281 16.8044C15.502 18.7701 12.8946 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 12.5636 19.0353 14.9019 17.4492 16.6717C17.4574 16.7043 17.4654 16.7371 17.4732 16.7701L17.3281 16.8044ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.7512 17.4373 13.3709 16.483 14.6883C16.4787 14.6833 16.4745 14.6783 16.4702 14.6733C15.9897 14.1093 15.3996 13.7355 14.7537 13.4902C13.5207 13.0218 11.9981 13 10.5 13H9.50002C8.01571 13 6.58663 13.0178 5.4546 13.5071C4.72237 13.8235 4.15855 14.3097 3.73753 14.9786C2.6499 13.6123 2 11.8821 2 10ZM5.23094 16.4237C6.56265 17.414 8.2129 18 10 18C11.9364 18 13.7121 17.312 15.096 16.1672C15.048 16.0951 14.9985 16.0298 14.9479 15.9704C14.7202 15.7032 14.4289 15.5062 14.0436 15.3598C13.2144 15.0449 12.0755 15 10.5 15H9.50002C7.91075 15 6.9284 15.0489 6.2481 15.3429C5.85089 15.5146 5.50217 15.7968 5.23094 16.4237Z",
    fill: "#3C83ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fe835c8fc004c09244ef906fa2d26e97.svg";
export { ForwardRef as ReactComponent };